import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Modal from "react-modal";
import posthog from "posthog-js";

const posthogProjectToken = process.env.REACT_APP_POSTHOG_PROJECT_TOKEN;
const posthogHost = process.env.REACT_APP_POSTHOG_HOST;
const isPostHogConfigured = Boolean(posthogProjectToken && posthogHost);

if (!isPostHogConfigured && process.env.NODE_ENV !== "test") {
  console.warn(
    "PostHog is disabled because REACT_APP_POSTHOG_PROJECT_TOKEN or REACT_APP_POSTHOG_HOST is missing."
  );
}

if (isPostHogConfigured) {
  posthog.init(posthogProjectToken, {
    api_host: posthogHost,
    defaults: "2026-01-30",
    capture_exceptions: {
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
      capture_console_errors: false,
    },
  });
}

Modal.setAppElement("#root");

ReactDOM.render(
  <App />,
  document.getElementById("root")
);
